module.exports = "<listado-general \r\n  [listado]= tiposolicitud \r\n  [titulo]=\"'SOLICITUDES_DISPONIBLES' | translate\"\r\n  [urladicional]=\"''\"\r\n  [ocultarNuevo]=\"false\"\r\n  [leyendaListado]=\"'SOLICITUDES_DISPONIBLES_LEYENDA' | translate\"\r\n  (clickNuevo)=\"navegarNuevoTipoSolicitud()\">\r\n</listado-general>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/tiposolicitud/listado.tiposolicitud.component.html
// module id = ../../../../../src/app/private/tiposolicitud/listado.tiposolicitud.component.html
// module chunks = main